import axios from "axios";
import { getAccess, refreshAccessToken, clearTokens } from "../utils/authUtils";

const baseURL = process.env.REACT_APP_BACKEND_URL;

const axiosInstance = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Request Interceptor: Adds the Auth Token to every request automatically
axiosInstance.interceptors.request.use(
    async (config) => {
        const token = getAccess();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor: Handles 401 errors (Expired Token)
axiosInstance.interceptors.response.use(
    (response) => response, // If response is good, just return it
    async (error) => {
        const originalRequest = error.config;

        // If error is 401 and we haven't retried yet
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true; // Mark as retried so we don't loop forever

            try {
                // Call existing refresh logic
                const newAccessToken = await refreshAccessToken(); 
                
                if (newAccessToken) {
                    // Update the header for the retry
                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                    // Retry the original request with the new token
                    return axiosInstance(originalRequest);
                }
            } catch (refreshError) {
                // If refresh fails, logout user
                console.error("Session expired", refreshError);
                clearTokens();
                window.location.href = "/login"; // Optional: Redirect to login
            }
        }
        
        return Promise.reject(error);
    }
);

export default axiosInstance;